<template>
  <div class="d-flex mt-2" style="flex-direction: column; overflow-y: auto; max-height: 350px">
    <div v-for="(verlaegerung, index) in groupedByLocation" :key="verlaegerung.id">
      <div>
        <!-- Name der Verlängerung -->
        <b>
          {{
            verlaegerung.beschreibung.includes('Verlängerungspaket')
              ? verlaegerung.beschreibung.replace('Verlängerungspaket', 'Paket')
              : verlaegerung.beschreibung.replace('Verlängerung', '').trim()
          }}
        </b>

        <div
          class="d-flex mt-2 justify-content-between"
          v-for="hotel in groupedHotels(verlaegerung.items)"
          :key="hotel.name"
        >
          <!-- Name des Hotels -->
          <div class="mr-2">{{ hotel.name }} ({{ getKuerzel(hotel.name, hotel.beschreibung) }}):</div>

          <div class="d-flex align-items-center" style="gap: 8px">
            <!-- Widgets für die Hotels -->
            <div
              v-for="widget in hotel.widgets"
              :key="widget.id"
              class="zimmerkontingent-badge"
              :class="istBgColor(widget.item)"
            >
              <div class="zimmerkontingent-status">
                {{ statusLabel(widget) }}
              </div>
              <!--  Hier steht dann "DZ" oder "EZ" -->
              <div class="zimmerkontingent-zimmertyp">
                {{ widget.zimmertyp }}
              </div>
            </div>
          </div>
        </div>
        <hr v-if="index < groupedByLocation.length - 1" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    verlaengerungen: {
      type: Array,
      required: true,
    },
    reiseterminId: {
      type: Number,
    },
  },
  computed: {
    groupedVerlaengerungen() {
      if (!this.verlaengerungen) return [];

      const processStatus = status => {
        // Filter nach Status
        const filtered = this.verlaengerungen.filter(v => v.verfuegbarkeitsStatus === status);

        // Gruppiere nach Beschreibung UND Hotelname
        const grouped = filtered.reduce((acc, curr) => {
          const key = `${curr.beschreibung}-${curr.name}`;
          if (!acc[key]) {
            acc[key] = {
              beschreibung: curr.beschreibung,
              verfuegbarkeitsStatus: status,
              name: curr.name,
              zimmertypen: {},
            };
          }
          // Füge Zimmertyp hinzu
          acc[key].zimmertypen[curr.zimmertyp] = curr.einheitenFrei;
          return acc;
        }, {});

        return Object.values(grouped);
      };

      const aufAnfrage = processStatus('AufAnfrage');
      const verfuegbar = processStatus('Verfuegbar');

      // Kombiniere die Ergebnisse und filtere leere Objekte
      return [...verfuegbar, ...aufAnfrage].filter(item => Object.keys(item.zimmertypen).length > 0);
    },

    groupedByLocation() {
      const groups = this.groupedVerlaengerungen.reduce((acc, item) => {
        if (!acc[item.beschreibung]) acc[item.beschreibung] = { beschreibung: item.beschreibung, items: [] };
        acc[item.beschreibung].items.push(item);
        return acc;
      }, {});

      return Object.values(groups);
    },
  },
  methods: {
    groupedHotels(items) {
      const hotelGroups = items.reduce((acc, item) => {
        // wenn das Hotel noch nicht im acc ist, dann wird ein neues Hotel Objekt erstellt
        if (!acc[item.name]) {
          acc[item.name] = {
            name: item.name,
            // das ist das Kürzel des Hotels
            beschreibung: item.beschreibung,
            // ein array von Widgets
            widgets: [],
          };
        }

        // Es werden hier die Widgets erstellt und in das widgets-Array gepusht
        Object.entries(item.zimmertypen).forEach(([zimmertyp, value]) => {
          acc[item.name].widgets.push({
            id: `${item.id}-${zimmertyp}`,
            zimmertyp, // "DZ" oder "EZ"
            value, // die Anzahl der Zimmer
            item, // referenz auf das ursprüngliche Item
          });
        });

        return acc;
      }, {});

      return Object.values(hotelGroups);
    },
    istBgColor(item) {
      return item.verfuegbarkeitsStatus == 'Verfuegbar'
        ? 'green'
        : item.verfuegbarkeitsStatus == 'NichtVerfuegbar'
        ? 'red'
        : 'gray';
    },
    statusLabel(widget) {
      return widget.item.verfuegbarkeitsStatus == 'Verfuegbar'
        ? widget.value
        : widget.item.verfuegbarkeitsStatus == 'NichtVerfuegbar'
        ? 'N'
        : 'RQ';
    },
    getKuerzel(name, beschreibung) {
      if (this.verlaengerungen) {
        const kuerzel = this.verlaengerungen.find(
          item => item.name === name && item.beschreibung === beschreibung
        )?.kuerzel;
        return kuerzel;
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/sass/components/mixins/_kachel-badge.scss';

.zimmerkontingent-badge {
  @include kachel-badge-base;
  flex-direction: column;
  padding: 4px;
  width: 33px;

  @include kachel-badge-colors;
}
.zimmerkontingent-status {
  font-weight: 700;
  font-size: 12px;
  line-height: 12px;
}
.zimmerkontingent-zimmertyp {
  display: flex;
  align-items: flex-start;
  gap: 2px;
  font-weight: 400;
  font-size: 9px;
  line-height: 11px;
}
</style>
